import { useEffect, useRef } from "react";
import { getEcho } from "../helpers/echo";

/**
 * Subscribe to a private broadcast channel and listen for events.
 *
 * @param {string|null} channelName  Private channel name (e.g. `user.${userId}`)
 * @param {string}      eventName    Broadcast event name (e.g. `.shift.warning`)
 * @param {Function}    handler      Callback receiving the event payload
 */
export function useChannel(channelName, eventName, handler) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const echo = getEcho();
    if (!echo || !channelName) return;

    const channel = echo.private(channelName);
    const wrappedHandler = (e) => handlerRef.current(e);
    channel.listen(eventName, wrappedHandler);

    return () => {
      channel.stopListening(eventName, wrappedHandler);
    };
  }, [channelName, eventName]);
}
